import { State } from 'src/types'
import { crossDoubleWeb, crossDoubleWebWithEdge } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/web/crossDoubleWeb'
import { crossWeb, crossWebCenterStitch } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/web/crossWeb'
import { flatWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/web/flatWeb'
import { hWebWithEdge } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/web/hWebWithEdge'
import { laceOfCrossWebWithHalfNetUpper, laceOfNetWeb, net2Web, netWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/web/netWeb'
import { laceOfNetWebDouble } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/web/laceOfNetWebDouble'
import { basketForPitcherWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/web/basketWeb'
import { onePeaceWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/web/onePeaceWeb'
import { twoPeaceWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/web/twoPeaceWeb'
import { underWeb as laceOfUnderWeb, underWeb, underWebReinforcement } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/lace/underWeb'
import { indexWrapBack } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/lace/connectIndexToWeb'
import { wo5Web } from './wo5Web'
import { wi8Web } from './wi8Web'
import { wi7Web } from './wi7Web'
import { wp5Web } from './wp5Web'
import { wp4Web } from './wp4Web'
import { wi10Web } from './wi10'
import { webDrawUtil } from 'src/features/brands/util/canvas'

export const webOfGloveFrontDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, laceColor, stitchColor, edgeColor } = webDrawUtil(state)
  if (webMatcher(['wp1'])) flatWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wp2'])) basketForPitcherWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wp3'])) twoPeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wp4'])) wp4Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wp5'])) wp5Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wi1'])) hWebWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['wi2', 'wi3', 'wi9'])) crossWebCenterStitch(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wi4'])) crossWeb(ctx, edgeColor, webColor, laceColor, stitchColor)
  if (webMatcher(['wi6'])) onePeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wi7'])) wi7Web(ctx, webColor, laceColor, stitchColor, edgeColor)
  if (webMatcher(['wi5', 'wo1'])) netWeb(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['wi8'])) wi8Web(ctx, laceColor, stitchColor, webColor)
  if (webMatcher(['wi10'])) wi10Web(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['wo2'])) net2Web(ctx, edgeColor, laceColor, stitchColor, webColor)
  if (webMatcher(['wo3'])) crossDoubleWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wo4'])) crossDoubleWebWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['wo5'])) wo5Web(ctx, laceColor, stitchColor, webColor, webColor)
}

export const rightLaceOfNetWebDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, laceColor, stitchColor } = webDrawUtil(state)
  if (webMatcher(['wi5', 'wo1', 'wo2'])) laceOfNetWeb(ctx, laceColor)
  // ネットウェブ紐増量
  const condNetWebDouble = webMatcher(['wo2'])
  if (condNetWebDouble) laceOfNetWebDouble(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wi10'])) laceOfCrossWebWithHalfNetUpper(ctx, laceColor)
  if (!condNetWebDouble) {
    // 補強レース
    if (state.baseModel.productNumber !== 'U300') underWebReinforcement(ctx, laceColor)
    underWeb(ctx, laceColor, 10, 0) // ウェブ下＿右
    underWeb(ctx, laceColor, -32, 64) // ウェブ下＿左
    indexWrapBack(ctx, laceColor, -10, -100) // 上
    if (state.webParts?.value !== 'wi5') indexWrapBack(ctx, laceColor, 0, 0) // 下
  }
}

export const laceOfUnderWebDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, laceColor } = webDrawUtil(state)
  if (webMatcher(['wp3'])) laceOfUnderWeb(ctx, laceColor, -10, 30)
}
